import {useState,useEffect, useContext} from 'react'
import {Helmet} from "react-helmet";
import React, {Component} from "react";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigationMenuToggle from '../../../Components/Navigation/NavigationMenuToggle'
import {Link} from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Button from '@mui/material/Button';
import ValidateUser from '../../../Components/UserCredentials/ValidateUser';
import { GeneralFunctionsContext } from '../../../Components/Contexts/GeneralFunctionsContext';
export default function EarningsForArtists () {
    const navigate = useNavigate();
    const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    useEffect(()=>{
        window.scrollTo(0, 0)
    },[])


    return (
        <>
        <ValidateUser/>
        <Helmet>
            <title>Earnings For Artists</title>
            <meta property="og:title" content="Earnings For Artists" />
            <meta name="title" content="Earnings For Artists"/>
            <meta name="description" content="Earnings For Artists"/>
            <meta property="og:image" content="/assets/images/geniux_music_logo.png"/>
        </Helmet>
        
        <>
        <div className='has-hero-banner'>
            
             <div className={offset > 20 ? "navbar active" : "navbar"}>
                <div className="wrapper">
                    <div className="lft">
                        <IconButton className="icon" onClick={()=> navigate(-1)}>
                            <ArrowBackIcon />
                        </IconButton> 
                        <div className="titles">
                            <p>FOR ARTISTS</p>
                        </div>
                    
                    </div>
                    <div className="rgt">
                        <NavigationMenuToggle/>
                    </div>
                </div>
            </div> 
            
            
            <div className="mycontainer">
                <div className="hero-banner">
                    <div className="background">
                        <img src="/assets/images/geniux-music-banner-desktop-slide-1.jpg?geniuxmusic" className="bg-image"/>
                        <div className="bg-fade"></div>
                    </div>
                    {/* My  path */}
                    {/* {innerWidth>992 &&(
                        <div className="mypath">
                            <div className="wrapper">
                                <div className="lft">
                                    {window.history.length>1?
                                    <Button onClick={()=>navigate(-1)}>
                                        <KeyboardBackspaceIcon/>
                                    </Button>  
                                    :
                                    <Button onClick={()=>navigate(-1)} disabled="true">
                                        <KeyboardBackspaceIcon/>
                                    </Button>  
                                    }
                                </div>
                                <div className="rgt">
                                    <p>
                                        <Link to="/settings" className="active">EARNINGS</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )} */}
                </div>
               
                <div className="wrapper">
                    <br/>
                    <div className="htitle">
                        <div className="lft"><p>Earn from Your Songs – Designed for Artists</p></div>
                    </div>
                    <p>
                        Your music has value. Not just creatively, but financially. That’s why our platform is built with one goal in mind: to help artists like you turn streams into income. Whether you’re an independent artist just starting out or an established name looking for new ways to monetize your catalog, we provide a simple and transparent way to earn from every play.
                        <br/><br/>
                        No gatekeepers. No waiting for labels or distribution deals. Just a powerful, artist-first ecosystem that rewards you for the music you create and share with the world.
                        <br/>
                    </p>
                    <div className="htitle mb-0">
                        <div className="lft"><p>How it works:</p></div>
                    </div>
                    <p className="mt-2">
                        Every time your track is streamed on our platform, you get paid—simple as that. We believe in fair compensation for your creativity, so we’ve eliminated the middlemen, complicated licensing agreements, and hidden fees. Instead, you’ll receive transparent, stream-based payouts directly tied to how often your music is played. 
                        <br/><br/>
                        The more your songs are heard, the more you earn—no strings attached, no fine print.
                    </p>
                    <div className="htitle mb-0">
                        <div className="lft"><p>Key Features:</p></div>
                    </div>
                    <div className='feature-list mt-2'>
                        <p>💰 Real-Time Earnings Dashboard: Track your income with live updates on streams and revenue.</p>
                        <p>📊 Detailed Analytics: See where your listeners are coming from, what’s trending, and how each track performs.</p>
                        <p>🔁 Royalty-Based Payouts: Get paid fairly based on the number of plays your music receives.</p>
                        <p>💼 Artist Wallet: Securely store your earnings and withdraw anytime.</p>
                        <p>🚀 Promotion Tools: Boost your song visibility and maximize your reach to earn more.</p>
                    </div>

                    <div className="htitle mb-0 mt-4">
                        <div className="lft"><p>Join today and unlock your earning journey:</p></div>
                    </div>
                    <p className='mt-2'>
                        A small join fee is required to unlock this earning feature in the app. This helps us maintain a fair and secure experience for all users.
                    </p>
                     <div className='feature-list mt-2 mb-4'>
                        <p><b>Amount to pay: R379.00/year</b> <br/>Once paid, your account will remain active for a full year.</p>
                    </div>

                    <Button variant="outlined">Pay now & Join</Button>
                    

                    
                </div>
            </div>
        </div>
        </>

        
        </>
    )
}



